import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { Filter } from 'labstep-web/constants/filters';

export const bulkActions = [
  BulkAction.delete,
  BulkAction.tag,
  BulkAction.add_to_folder,
  BulkAction.remove_from_folder,
];

export const filters = [
  Filter.created_by,
  Filter.date_range,
  Filter.deleted,
  Filter.tag,
];
